import Mdatatable from "components/Datatables/Mdatatables";
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Notifications from "components/Notifications";
import DeleteConfirmationModel from "components/delete-confirmation-model";
import { getCode, userModuleData } from 'helpers/basic_helper';
import { MASTER_OPTIONS_URL } from "helpers/url_helper";
import { useDispatch, useSelector } from 'react-redux';
import { masterOptions } from 'store/actions';
import { GetHelper, SubmitHelper } from '../CallHelper';
import FormComponent from "../FormComponent";
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";

const isType = 'cities'
const Cities = () => {
    const dispatch = useDispatch()
    const { loading, cities, DDMasters } = useSelector(state => state.Master);
    const [open, isOpen] = useState(false)
    const [editableObj, setEditableObj] = useState(null)
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isEdit, setIsEdit] = useState(false)
    const [isDeleteModel, setIsDeleteModel] = useState(false)
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [error, setError] = useState(false)
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })

    useEffect(async() => {
        const data =  await userModuleData('masters', 'cities')
        setIsActions(data)
        if(data && (data.edit || data.delete)){
            setIsActionColumn(true)
        }
    }, [])

    /**
     * Get All Rows
     * @param {row_id} ID 
     * @method {get} GET 
     */
    const getData = async(ID = false) => {
        if (!ID) setIsLoading(true);
        try {
            const res = await GetHelper(`${process.env.REACT_APP_CITIES}&page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, ID)
            if(ID){
                setEditableObj(...res)
                isOpen(true)
                setIsEdit(false)
            }else{
                setDataRows(res)
            }
        } catch(err) {
            console.error("Cities getData error:", err)
        } finally {
            setIsLoading(false)
        }
    }
    
    useEffect(() => {
        dispatch(masterOptions({url:MASTER_OPTIONS_URL}))
    },[])

    /**
     * Submit or Update data Api Call
     * @param {Form Data} data 
     * @method {post} POST 
     */
    const submitForm = async(data) => {
        const checkCode = dataRows?.rows?.filter(v => (v.code).toUpperCase() == (data.target.code.value).toUpperCase())
        if(data?.target?.id?.value =='' &&  checkCode.length > 0) {
            Notifications('please enter unique code.!', 'error')
            return;
        }

        const res = await SubmitHelper(`${process.env.REACT_APP_CITIES}`, {
            "title": data.target.title.value,
            "code": data.target.code.value,
            "state": data.target.state.value,
            "country": data.target.country.value
        }, data?.target?.id?.value || null);

        if(res){
            getData()
            isOpen(false)
            Notifications('Country Added Successful.!')
        }
    }

    /**
     * Get Single row using url params ?q=?
     * @param {Row_id} q 
     * @method {get} GET 
     */
    const handleEdit = q => {
        if(q > 0){
            setIsEdit(q)
            getData(q)
        }
    }

    /**
     * Chnage Row Status By ID and condition Based Status passing,
     * @param {row_id} q 
     * @param {row Status} status 
     * @method {del} DELETE 
     */
    const handleRemove = async(q, status, code) => {
        if(q > 0) {
            setIsDeleteModel({url: process.env.REACT_APP_CITIES, q, status, code})
        }
    }

    const hideModel = () => {
        setIsDeleteModel(false)
        getData()
    }

    // table Column Data
    let datatableData = [
        {
            dataField: 'id',
            text: 'Id'
        }, {
            dataField: 'title',
            text: 'City'
        },{
            dataField: 'code',
            text: 'Code'
        },{
            dataField: 'state_title',
            text: 'State'
        },{
            dataField: 'country_title',
            text: 'Country'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Track or status" ><i className={`fas fa-pencil-alt`} /></Link>
                <Link to="#" className="ms-1 btn btn-outline-danger btn-sm edit" onClick={() => handleRemove(row.id, row.status, row.code)} title="Track or status" ><i className={`fas fa-trash-alt`} /></Link>
            </>
        }
    ];

    /**
     * HTML Form Columns 
     */
    let htmlFormFields = [
        {
            name: "id",
            required: false,
            type: 'hidden',
            value: editableObj?editableObj.id : '',
            col:12
        },{
            name: "title",
            label: "City Name",
            placeholder: "City Name",
            required: true,
            type: 'text',
            value: editableObj?editableObj.title : '',
            col:12
        },{
            name: "code",
            label: "Code",
            placeholder: "Code",
            required: true,
            type: 'text',
            value: editableObj?editableObj.code: getCode("cities", dataRows?.total_rows),
            col: 12
        },{
            name: "country",
            label: "Country",
            placeholder: "Country",
            required: true,
            type: 'select',
            options: DDMasters?.countries?.map( v => ({'label': v.title, 'value': v.code})),
            value: editableObj? DDMasters?.countries?.filter(x => x.code == editableObj.country ).map( v => ({'label': v.title, 'value': v.code})) : '',
            col:12
        },{
            name: "state",
            label: "State",
            placeholder: "State",
            required: true,
            type: 'select',
            options: DDMasters?.states?.map( v => ({'label': v.title, 'value': v.code})),
            value: editableObj? DDMasters?.states?.filter(x => x.code == editableObj.state ).map( v => ({'label': v.title, 'value': v.code})) : '',
            col:12
        }
    ]

    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);    

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Dashboard | {isType}</title></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Masters" breadcrumbItem={isType} />
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables 
                                        isSearch={true}
                                        columns = {datatableData}
                                        showTableOnly={true}
                                        rowsLength = {dataRows?.total_rows || 0}
                                        rows = {dataRows?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={()=>{
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}            
                                        title = "All Cities"
                                        loading={isLoading}
                                        isAdd = {true}
                                        isTableHead = {true}
                                        ssr={setPagination}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            {/* Datatable */}
            {
                open &&
                <FormComponent
                    title={`${editableObj ? 'Edit' : 'Add'} City`}
                    Position={"right"}
                    isOpen={open}
                    fileds={htmlFormFields}
                    loading={isLoading}
                    editableObj={editableObj}
                    onDrawerClose={() => {
                        setEditableObj(null)
                        isOpen(false)
                    }}
                    submitForm={submitForm}
                />
            }
            {/* End Datatable */}

            { isDeleteModel && <DeleteConfirmationModel isOpen={true} changeState={hideModel} code={isDeleteModel} /> }
        </React.Fragment>
    )
}

export default Cities
